export type CompraReciente = {
  nombre: string
  ciudad: string
  minutos: number
}

export const comprasRecientes: CompraReciente[] = [
  { nombre: 'Valentina M.', ciudad: 'Buenos Aires, Argentina', minutos: 2 },
  { nombre: 'Andrés P.', ciudad: 'Bogotá, Colombia', minutos: 4 },
  { nombre: 'Lucía F.', ciudad: 'Madrid, España', minutos: 6 },
  { nombre: 'Javier T.', ciudad: 'Ciudad de México, México', minutos: 8 },
  { nombre: 'Camila S.', ciudad: 'Santiago, Chile', minutos: 11 },
  { nombre: 'Mateo R.', ciudad: 'Montevideo, Uruguay', minutos: 13 },
  { nombre: 'Daniela V.', ciudad: 'Lima, Perú', minutos: 15 },
  { nombre: 'Sebastián L.', ciudad: 'Guayaquil, Ecuador', minutos: 17 },
  { nombre: 'Paula G.', ciudad: 'Barcelona, España', minutos: 19 },
  { nombre: 'Rodrigo C.', ciudad: 'Medellín, Colombia', minutos: 22 },
  { nombre: 'Fernanda O.', ciudad: 'Guadalajara, México', minutos: 24 },
  { nombre: 'Nicolás B.', ciudad: 'Córdoba, Argentina', minutos: 27 },
  { nombre: 'Gabriela H.', ciudad: 'San José, Costa Rica', minutos: 29 },
  { nombre: 'Emilio D.', ciudad: 'Ciudad de Panamá, Panamá', minutos: 32 },
  { nombre: 'Sofía N.', ciudad: 'Valencia, España', minutos: 35 },
  { nombre: 'Martín A.', ciudad: 'Asunción, Paraguay', minutos: 38 },
  { nombre: 'Isabel Q.', ciudad: 'Santo Domingo, Rep. Dominicana', minutos: 41 },
  { nombre: 'Tomás E.', ciudad: 'Cancún, México', minutos: 44 },
]
